


























import { Component, Vue, Prop } from 'vue-property-decorator'
import { UnitActionData } from '@/api/heritageUnit/unitBase'

@Component
export default class UnitActionsView extends Vue {
  public name = 'UnitActionsView'
  @Prop({ default: null })
  public dataList: UnitActionData[] = []
}
